import useVuelidate from '@vuelidate/core'

export default {
    setup(props, context) {
        return {
            v$: useVuelidate()
        }
    }
}